export default (file: File | Blob, fileName: string): void => {
  const url = window?.URL?.createObjectURL?.(file);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window?.URL?.revokeObjectURL?.(url);
};
